import { render } from "./NotificationDetailModal.vue?vue&type=template&id=fea66e1a&ts=true"
import script from "./NotificationDetailModal.vue?vue&type=script&lang=ts"
export * from "./NotificationDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__